var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-row',[_c('el-col',_vm._l((_setup.assets),function(item){return _c('a',{staticClass:"option-btn download-btn primary",class:!item.href ? 'disabled': '',attrs:{"href":item.href,"target":"_blank"}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }